/***
 * Configuration for Progressive Web App Routes
 *
 * Progressive Web App Routes
 ***/

/* ----- Views ----- */

import ProgressiveWebAppDashboard from "@/pages/ProgressiveWebApp/ProgressiveWebAppDashboard";
import PwaPlanning from "@/pages/ProgressiveWebApp/Planning/PwaPlanning";
import PwaInterventionDetails from "@/pages/ProgressiveWebApp/Planning/PwaInterventionDetails";
import PwaInterventionDevices from "@/pages/ProgressiveWebApp/Planning/devices/PwaInterventionDevices";
import PwaInterventionDeviceReport from "@/pages/ProgressiveWebApp/Planning/devices/PwaInterventionDeviceReport";
import PwaInterventionReport from "@/pages/ProgressiveWebApp/Planning/PwaInterventionReport";
import PwaInterventionSignature from "@/pages/ProgressiveWebApp/Planning/PwaInterventionSignature";
import PwaInterventionClosure from "@/pages/ProgressiveWebApp/Planning/PwaInterventionClosure";
import PwaInterventionDemand from "@/pages/ProgressiveWebApp/Planning/PwaInterventionDemand";
import PwaInterventionSitePlan from "@/pages/ProgressiveWebApp/Planning/PwaInterventionSitePlan";

/* ----- ----- ----- ----- ----- ----- ----- */

const progressiveWebAppRoutes = [
    {
        path: "dashboard",
        name: "Pwa Dashboard",
        component: ProgressiveWebAppDashboard,
        meta: {}
    },
    {
        path: "planning",
        name: "Pwa Planning",
        component: PwaPlanning,
        meta: {}
    },
    {
        path: "planning/:interventionId",
        name: "Pwa Intervention Details",
        component: PwaInterventionDetails,
        meta: {}
    },
    {
        path: "planning/:interventionId/devices",
        name: "Pwa Intervention Devices Details",
        component: PwaInterventionDevices,
        meta: {}
    },
    {
        path: "planning/:interventionId/devices/:deviceId/report",
        name: "Pwa Intervention Device Report",
        component: PwaInterventionDeviceReport,
        meta: {}
    },
    {
        path: "planning/:interventionId/report",
        name: "Pwa Intervention Report",
        component: PwaInterventionReport,
        meta: {}
    },
    {
        path: "planning/:interventionId/signature",
        name: "Pwa Intervention Signature",
        component: PwaInterventionSignature,
        meta: {}
    },
    {
        path: "planning/:interventionId/closure",
        name: "Pwa Intervention Closure",
        component: PwaInterventionClosure,
        meta: {}
    },
    {
        path: "planning/:interventionId/demand",
        name: "Pwa Intervention Demand",
        component: PwaInterventionDemand,
        meta: {}
    },
    {
        path: "planning/:interventionId/plans/:planId",
        name: "Pwa Intervention Site Plan",
        component: PwaInterventionSitePlan,
        meta: {}
    },
]
export default progressiveWebAppRoutes